import React, { useContext } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigContext } from "../../context/config";
import { setShowIFrame } from "../../reducers/auth/action";
import useIdentity from "../../utils/identity";

const Iframe = () => {
  const { iframe: iframeRef } = useContext(ConfigContext);
  const dispatch = useDispatch();
  const { showIframe } = useSelector((state) => state.auth);

  return (
    <iframe
      id="identity"
      frameBorder="0"
      src="https://identity.deso.org/embed"
      title="iframe"
      style={{
        height: "100vh",
        width: "100vw",
        display: showIframe ? "block" : "none",
        position: "fixed",
        left: "0",
        top: "0",
        zIndex: "1000",
      }}
      ref={iframeRef}
    />
  );
};

export default Iframe;
